import { WSQueryConfig } from "@ws-react-query";
import { useWSQuery } from "../../helpers";

import { QUERY_INVITATION_BY_TOKEN } from "../keys";
import { getInvitation } from "../../../services/invitations";
import { IInvitationResponse } from "@wingspanhq/users";
import { WSServiceError } from "../../../utils/serviceHelper";

export const useQueryInvitation = (
  token: string,
  queryConfig?: WSQueryConfig<IInvitationResponse, WSServiceError>
) =>
  useWSQuery([QUERY_INVITATION_BY_TOKEN, token], () => getInvitation(token), {
    retry: false,
    ...queryConfig
  });
